module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/141-azerbaijan-d60bf12358e7b66341dd2084640c93e4.svg";